import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"

import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"
import * as constants from "../constants"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

import { Lightbox } from "react-modal-image"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import ReactHTMLTableToExcel from "react-html-table-to-excel"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

const   optionParamStepMain= [{value:1,label:"پارامتر اصلی"},{value:0,label:"پارامتر اضافی"}]



class ChangeParamStepFieldInsurance extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  paramstep_id: "",
                  paramstep_name: "",
                  paramstep_num: "",
                  paramstep_group: "",
                  selectedFieldinsurance: "",
                  selectedTimeanswer_complaints: "",
                  selectedCustomer_satisfaction: "",
                  selectedNum_branchesdamages: "",

                  paramstep_desc: "",
                  paramstep_apiorname: "",
                  paramstep_defultvalue: "",
                  paramstep_filter: "",
                  paramstep_getprice_condition: "",
                  paramstep_display_condition: "",
                  paramstep_link: "",
                  paramstep_image_url: "",
                  orderBy: "paramstep_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newParamStep: true,
                  picturesRequestReady: "",
                  loading: false,
                  percent: 0,
                  optionFieldinsurance: [],

                  urlToLargeImageFile: "",
                  urlToHugeImageFile: "",
                  descImageFile: "",
                  openImageBox: false,
                  openDialog: false,

                  selectedParamStepMode: "",
                  optionParamStepMode: [],

                  selectedParamStepMain: optionParamStepMain[0],


                  selectedFilterFieldinsurance: "",
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      setImageModel = (image, largimage, desc) => {
            this.setState({
                  urlToLargeImageFile: largimage,
                  urlToHugeImageFile: image,
                  descImageFile: desc,
                  openImageBox: true,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      handleChangeParamstepName = (event) => {
            this.setState({ paramstep_name: event.target.value })
      }

      handleChangeParamstepNum = (event) => {
            this.setState({ paramstep_num: event.target.value })
      }

      handleChangeParamstepGroup = (event) => {
            this.setState({ paramstep_group: event.target.value })
      }


      onSelectPicRequest = (picture) => {
            this.setState({
                  picturesRequestReady: picture[0],
            })
      }

      handleChangeParamstepDesc = (event) => {
            this.setState({ paramstep_desc: event.target.value })
      }

      handleChangeParamstepApiorname = (event) => {
            this.setState({ paramstep_apiorname: event.target.value })
      }

      handleChangeParamstepDefultValue = (event) => {
            this.setState({ paramstep_defultvalue: event.target.value })
      }

      handleChangeParamstepFilter = (event) => {
            this.setState({ paramstep_filter: event.target.value })
      }

      handleChangeParamstepGetPriceCondition = (event) => {
            this.setState({ paramstep_getprice_condition: event.target.value })
      }

      handleChangeParamstepDisplayCondition = (event) => {
            this.setState({ paramstep_display_condition: event.target.value })
      }


      handleChangeParamstepLink = (event) => {
            this.setState({ paramstep_link: event.target.value })
      }

      handleLevelof_prosperity = (selectedFieldinsurance) => {
            this.setState({ selectedFieldinsurance: selectedFieldinsurance }, () => {
                  this.filterManagDiscount()
            })
      }


      handleParamStepMode = (selectedParamStepMode) => {
            this.setState({ selectedParamStepMode: selectedParamStepMode }, () => {

            })
      }

      handleParamStepMain = (selectedParamStepMain) => {
            this.setState({ selectedParamStepMain: selectedParamStepMain }, () => {

            })
      }


      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        paramstep_id: row2.paramstep_id,
                        paramstep_name: row2.paramstep_name,
                        paramstep_num: row2.paramstep_num,
                        paramstep_group: row2.paramstep_group,
                        selectedParamStepMain:  optionParamStepMain.find((x) => parseInt(x.value) === parseInt(row2.paramstep_main)),
                        selectedParamStepMode: { value: row2.paramstep_field_kind_id, label: row2.field_kind_namefa },
                        selectedFieldinsurance: { value: row2.paramstep_fieldinsurance, label: row2.fieldinsurance_fa },
                        paramstep_desc: row2.paramstep_desc,
                        paramstep_apiorname: row2.paramstep_apiorname,
                        paramstep_defultvalue: row2.paramstep_defultvalue,
                        paramstep_filter: row2.paramstep_filter,
                        paramstep_getprice_condition: row2.paramstep_getprice_condition,
                        paramstep_display_condition: row2.paramstep_display_condition,
                        paramstep_link: row2.paramstep_link,
                        paramstep_image_url: row2.paramstep_image_url,
                        newParamStep: false,
                  },
                  () => {}
            )
      }

      newParamStep = (event) => {
            this.setState({
                  paramstep_id: "",
                  paramstep_name: "",
                  paramstep_num: "",
                  paramstep_group: "",
                  selectedFieldinsurance: {},
                  selectedParamStepMode: {},
                    selectedParamStepMain: {},
                    paramstep_desc: "",
                    paramstep_apiorname: "",
                    paramstep_defultvalue: "",
                    paramstep_filter: "",
                    paramstep_getprice_condition: "",
                    paramstep_display_condition: "",
                    paramstep_link: "",
                  paramstep_image_url: "",
                  newParamStep: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                self.getoptionFieldinsurance();
                                self.getoptionParamStepMode();
                          } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getoptionFieldinsurance = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].fieldinsurance, label: arr.data[k].fieldinsurance_fa })
                              }
                              self.setState({ optionFieldinsurance: Company, selectedFieldinsurance: Company[0] }, () => {
                                    self.getParamStep()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.send(fd)
      }


      getoptionParamStepMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].field_kind_id, label: arr.data[k].field_kind_namefa })
                              }
                              self.setState({ optionParamStepMode: Company, selectedParamStepMode: Company[0] }, () => {

                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_field_kind")
            xhttp.open("POST", `${constants.BASE_URL}/paramstep`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
          xhttp.send(fd)
      }


      getParamStep() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterManagDiscount()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "getparamstep")

            xhttp.open("POST", `${constants.BASE_URL}/paramstep`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewParamStep = (imageCode) => {
            const { paramstep_id, paramstep_name, paramstep_num, paramstep_group, selectedParamStepMode, selectedParamStepMain, selectedFieldinsurance, paramstep_desc, paramstep_apiorname, paramstep_defultvalue, paramstep_filter, paramstep_getprice_condition, paramstep_display_condition, paramstep_link } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(arr)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getParamStep()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "addparamstep")
            fd.append("paramstep_name", paramstep_name)
            fd.append("paramstep_num", paramstep_num)
            fd.append("paramstep_group", paramstep_group)
            fd.append("paramstep_main", selectedParamStepMain.value)
            fd.append("paramstep_field_kind_id", selectedParamStepMode.value)
            fd.append("paramstep_fieldinsurance", selectedFieldinsurance.value)
            fd.append("paramstep_desc", paramstep_desc)
            fd.append("paramstep_apiorname", paramstep_apiorname)
            fd.append("paramstep_defultvalue", paramstep_defultvalue)
            fd.append("paramstep_filter", paramstep_filter)
            fd.append("paramstep_getprice_condition", paramstep_getprice_condition)
            fd.append("paramstep_display_condition", paramstep_display_condition)
            fd.append("paramstep_link", paramstep_link)
            fd.append("paramstep_image_code", imageCode)

            xhttp.open("POST", `${constants.BASE_URL}/paramstep`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeParamStep = (imageCode) => {
            const { paramstep_id, paramstep_name, paramstep_num, paramstep_group, selectedFieldinsurance, selectedParamStepMode, selectedParamStepMain, paramstep_desc, paramstep_apiorname, paramstep_defultvalue, paramstep_filter, paramstep_getprice_condition, paramstep_display_condition, paramstep_link } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getParamStep()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modifyparamstep")
            fd.append("paramstep_id", paramstep_id)
            fd.append("paramstep_name", paramstep_name)
            fd.append("paramstep_num", paramstep_num)
            fd.append("paramstep_group", paramstep_group)
            fd.append("paramstep_main", selectedParamStepMain.value)
            fd.append("paramstep_field_kind_id", selectedParamStepMode.value)
            fd.append("paramstep_fieldinsurance", selectedFieldinsurance.value)
            fd.append("paramstep_desc", paramstep_desc)
            fd.append("paramstep_apiorname", paramstep_apiorname)
            fd.append("paramstep_defultvalue", paramstep_defultvalue)
            fd.append("paramstep_getprice_condition", paramstep_getprice_condition)
            fd.append("paramstep_display_condition", paramstep_display_condition)
            fd.append("paramstep_filter", paramstep_filter)
            fd.append("paramstep_link", paramstep_link)
            if (imageCode !== "") {
                  fd.append("paramstep_image_code", imageCode)
            }

            xhttp.open("POST", `${constants.BASE_URL}/paramstep`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteImageRequire = () => {
            const { paramstep_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getParamStep()
                              self.newParamStep()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "deleteparamstep")
            fd.append("paramstep_id", paramstep_id)

            xhttp.open("POST", `${constants.BASE_URL}/paramstep`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      uploadPicDelivery = (mode) => {
            const { picturesRequestReady, paramstep_name, paramstep_num, paramstep_group, selectedFieldinsurance, selectedParamStepMode, selectedParamStepMain, paramstep_desc, paramstep_link } = this.state
            if (paramstep_desc != "" && paramstep_link != "" && paramstep_name != "" && paramstep_num != ""&& paramstep_group != "" && selectedFieldinsurance != ""&& selectedParamStepMode != ""&& selectedParamStepMain != "") {
                  if (picturesRequestReady && picturesRequestReady !== "" && picturesRequestReady !== null) {
                        this.setState({
                              loading: true,
                              percent: 0,
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    console.log(arr)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          if (mode === "new") {
                                                self.saveNewParamStep(arr.data["image_code"])
                                          } else {
                                                self.changeParamStep(arr.data["image_code"])
                                          }
                                    } else if (arr.result === "error") {
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "uploadpic")
                        fd.append("image", picturesRequestReady)
                        fd.append("image_name", " تصویر عکس  " + paramstep_name + paramstep_num)
                        fd.append("image_desc", "تصویر عکس " + paramstep_name + paramstep_num)
                        fd.append("name", "")
                        xhttp.upload.addEventListener(
                              "progress",
                              function(evt) {
                                    if (evt.lengthComputable) {
                                          var percentComplete = evt.loaded / evt.total
                                          self.setState({
                                                percent: percentComplete * 100,
                                          })
                                    }
                              },
                              false
                        )
                        xhttp.open("POST", `${constants.BASE_URL}image`)
                        xhttp.send(fd)
                  } else {
                        console.log(mode)
                        if (mode === "new") {
                              this.saveNewParamStep("")
                        } else {
                              this.changeParamStep("")
                        }
                  }
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      handleFilterFieldinsurance = (selectedFilterFieldinsurance) => {
            this.setState({ selectedFilterFieldinsurance: selectedFilterFieldinsurance }, () => {
                  this.filterManagDiscount()
            })
      }

      filterManagDiscount = () => {
            const { selectedFieldinsurance, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (temparray[i].paramstep_fieldinsurance === selectedFieldinsurance.value) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  selectedFilterFieldinsurance,
                  urlToHugeImageFile,
                  descImageFile,
                  urlToLargeImageFile,
                  optionFieldinsurance,
                  selectedFieldinsurance,
                  optionParamStepMode,
                  selectedParamStepMode,
                  selectedParamStepMain,
                  loading,
                  percent,
                  selectedNum_branchesdamages,
                  selectedCustomer_satisfaction,
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newParamStep,
                  paramstep_id,
                  paramstep_name,
                  paramstep_num,
                  paramstep_group,
                  paramstep_image_url,
                  paramstep_desc,
                  paramstep_apiorname,
                  paramstep_defultvalue,
                  paramstep_filter,
                  paramstep_getprice_condition,
                  paramstep_display_condition,
                  paramstep_link,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"آی دی مرحله ورود پارامتر" + paramstep_id}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img
                                                                              alt=""
                                                                              className={classes.large}
                                                                              src={paramstep_image_url}
                                                                              onClick={() => {
                                                                                    this.setImageModel(
                                                                                          paramstep_image_url,
                                                                                          paramstep_image_url,
                                                                                          paramstep_name
                                                                                    )
                                                                              }}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">{"رشته بیمه"} </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"رشته بیمه"}
                                                                              value={selectedFieldinsurance}
                                                                              onChange={this.handleLevelof_prosperity}
                                                                              options={optionFieldinsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">{"نوع پارامتر "} </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع پارامتر "}
                                                                              value={selectedParamStepMode}
                                                                              onChange={this.handleParamStepMode}
                                                                              options={optionParamStepMode}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">{"مدل پارامتر "} </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"مدل پارامتر "}
                                                                              value={selectedParamStepMain}
                                                                              onChange={this.handleParamStepMain}
                                                                              options={optionParamStepMain}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="شماره مرحله "
                                                                      //  disabled={true}
                                                                        handleInputt={this.handleChangeParamstepNum}
                                                                        value={paramstep_num}
                                                                  />
                                                            </Grid>


                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="شماره گروه"
                                                                      //  disabled={true}
                                                                        handleInputt={this.handleChangeParamstepGroup}
                                                                        value={paramstep_group}
                                                                  />
                                                            </Grid>


                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام مرحله ورود پارامتر"
                                                                        handleInputt={this.handleChangeParamstepName}
                                                                        value={paramstep_name}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="لینک خارجی "
                                                                        handleInputt={this.handleChangeParamstepLink}
                                                                        value={paramstep_link}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات مرحله ورود پارامتر"
                                                                        handleInputt={this.handleChangeParamstepDesc}
                                                                        value={paramstep_desc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="وب سرویس یا نام فیلد"
                                                                        handleInputt={this.handleChangeParamstepApiorname}
                                                                        value={paramstep_apiorname}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="مقدار پیشفرض"
                                                                        handleInputt={this.handleChangeParamstepDefultValue}
                                                                        value={paramstep_defultvalue}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="مقدار فیلتر"
                                                                        handleInputt={this.handleChangeParamstepFilter}
                                                                        value={paramstep_filter}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="شرط قیمت دهی"
                                                                        handleInputt={this.handleChangeParamstepGetPriceCondition}
                                                                        value={paramstep_getprice_condition}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="شرط نمایش "
                                                                        handleInputt={this.handleChangeParamstepDisplayCondition}
                                                                        value={paramstep_display_condition}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <ImageUploader
                                                                        withIcon={true}
                                                                        buttonText="عکس را انتخاب نمایید"
                                                                        onChange={this.onSelectPicRequest}
                                                                        withPreview="true"
                                                                        singleImage="true"
                                                                        imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                        maxFileSize={5242880}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  {loading && <LinearProgress variant="determinate" value={percent} />}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newParamStep ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.uploadPicDelivery("new")
                                                                              }}
                                                                        >
                                                                              {"ثبت مرحله ورود پارامتر جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button variant="outlined" color="primary" onClick={this.newParamStep}>
                                                                                    {"مرحله ورود پارامتر جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.uploadPicDelivery("modify")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>

                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {"حذف مرحله ورود پارامتر مورد نیاز "}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <ReactHTMLTableToExcel
                                                            id="test-table-xls-button"
                                                            className="download-table-xls-button"
                                                            table="table-to-xls"
                                                            filename="tablexls"
                                                            sheet="tablexls"
                                                            buttonText="Download as XLS"
                                                      />

                                                      <TableContainer dir="rtl">
                                                            <Table id="table-to-xls" aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"fieldinsurance_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "fieldinsurance_fa" ? order : false}
                                                                              >
                                                                                    {"نام رشته"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_fa"}
                                                                                          direction={orderBy === "fieldinsurance_fa" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"field_kind_namefa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "field_kind_namefa" ? order : false}
                                                                              >
                                                                                    {"نوع پارامتر "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "field_kind_namefa"}
                                                                                          direction={orderBy === "field_kind_namefa" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("field_kind_namefa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"paramstep_main"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "paramstep_main" ? order : false}
                                                                              >
                                                                                    {"مدل پارامتر "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "paramstep_main"}
                                                                                          direction={orderBy === "paramstep_main" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("paramstep_main")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"paramstep_num"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شماره مرحله "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "paramstep_num"}
                                                                                          direction={orderBy === "paramstep_num" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("paramstep_num")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"paramstep_group"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شماره گروه "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "paramstep_group"}
                                                                                          direction={orderBy === "paramstep_group" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("paramstep_group")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"paramstep_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام مرحله ورود پارامتر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "paramstep_name"}
                                                                                          direction={orderBy === "paramstep_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("paramstep_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"paramstep_desc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" توضیحات مرحله ورود پارامتر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "paramstep_desc"}
                                                                                          direction={orderBy === "paramstep_desc" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("paramstep_desc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["paramstep_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"fieldinsurance_fa"} align={"center"}>
                                                                                                      {row["fieldinsurance_fa"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"field_kind_namefa"} align={"center"}>
                                                                                                      {row["field_kind_namefa"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"paramstep_main"} align={"center"}>
                                                                                                      {optionParamStepMain.find((x) => parseInt(x.value) === parseInt(  row["paramstep_main"])).label
                                                                                                      }
                                                                                                </TableCell>


                                                                                                <TableCell key={"paramstep_num"} align={"center"}>
                                                                                                      {row["paramstep_num"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"paramstep_group"} align={"center"}>
                                                                                                      {row["paramstep_group"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"paramstep_name"} align={"center"}>
                                                                                                      {row["paramstep_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"paramstep_desc"} align={"center"}>
                                                                                                      {row["paramstep_desc"]}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}

                              {this.state.openImageBox && (
                                    <Lightbox
                                          medium={urlToLargeImageFile}
                                          large={urlToHugeImageFile}
                                          alt={descImageFile}
                                          onClose={this.closeLightbox}
                                          showRotate={true}
                                          hideZoom={false}
                                    />
                              )}

                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید عکس مورد نیاز را پاک نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deleteImageRequire} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeParamStepFieldInsurance)
